import useUpdateDropTaskSubmissions from '../../../../hooks/useUpdateDropTaskSubmissions'
import SharedZapValueIndex, {
  Props,
} from '../../../../shared_components/Missions/Types/ZapValueIndex'

export default function ZapValueIndexTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount' | 'rewardDisplay'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedZapValueIndex
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      rewardDisplay='XP'
    />
  )
}
